import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CarouselComponent } from 'ngx-bootstrap/carousel';
import { DocumentsServe } from 'src/app/utils/constants';
import { environment } from 'src/environments/environment';
import { Gallery } from '../../utils/models/gallery';
@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
})
export class GalleryComponent implements OnInit, AfterViewInit {
  @Input() galleryList: Gallery[];
  @ViewChild('video') video: any;
  @ViewChild('carousel')
  carousel!: CarouselComponent;
  onPlay: boolean;
  urlServer: string;
  videoObj: any;

  constructor() {
    this.galleryList = [];
    this.onPlay = false;
    this.urlServer = 'https://tarjetasf.virtualplace.online/Empresas/Galeria/';
  }
  ngAfterViewInit(): void {
    //console.log(this.galleryList);
  }

  ngOnInit(): void {}

  playVideo(video: any) {
    this.videoObj = video;

    if (!this.onPlay) {
      video.play();
      this.onPlay = true;
      this.carousel.noPause = false;
      this.carousel.pause();
    } else {
      video.pause();
      this.onPlay = false;
      this.carousel.play();
    }
  }

  cambiaSlide() {
    if (this.videoObj != undefined) {
      this.videoObj.pause();
      this.onPlay = false;
    }
  }

  toggleMute(video: any) {
    video.muted = !video.muted;
  }

  log(event: number) {
    // setTimeout(() => {
    //   this.video.pause();
    // });
  }

  buildUrlGallery(service: Gallery): string {
    return (
      DocumentsServe.CARDPHOTOS + service.idTarjeta + '/' + service.urlFile
    );
  }

  typeService(service: string): string {
    const tmp = service.split('.');
    const typeService = tmp[tmp.length - 1];
    switch (typeService) {
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'PNG':
      case 'JPG':
      case 'JPEG':
        return 'image';
        break;
      case 'mp4':
      case 'mvk':
      case 'avi':
      case 'mov':
      case 'MP4':
      case 'MVK':
      case 'AVI':
      case 'MOV':
        return 'video';
        break;
      default:
        return '';
        break;
    }
  }
}
